import { ajaxErrorAlert, ajaxPost } from "./utils";
import { getJsContext } from "../app";
import { Modal } from "bootstrap";
import { openIframePopup } from "./common";

const body = $("body");

if (body.hasClass("transport")) {
  const compulsoryTransportForm = $("#compulsoryTransportForm"),
    verifyPhoneNumberModal = $("#verifyPhoneNumberModal"),
    verifyPhoneNumberForm = $("#verifyPhoneNumberForm");

  $("input[name=has_driving_license]").on("change", (e) => {
    if (e.target.value === "true") {
      $(".drivingLicenseInput").show().find("input").prop("required", true);
    } else {
      $(".drivingLicenseInput").hide().find("input").prop("required", false);
    }
  });

  compulsoryTransportForm.on("submit", (e) => {
    e.preventDefault();

    const form = $(e.target);
    const data = form.serializeArray();
    data.push({
      name: "action",
      value: "get_iframe_url",
    });
    form.loading({
      loadingText: getJsContext("please_wait") + "...",
      action: "show",
      extraClasses: "spinner-fixed",
    });
    ajaxPost("", data, form)
      .then((response) => {
        const action = response["action"];
        if (action === "verify_phone_number") {
          const modal = new Modal("#verifyPhoneNumberModal", {
            keyboard: false,
            backdrop: "static",
          });
          modal.show();
          verifyPhoneNumberModal
            .find('input[name="phone_number"]')
            .val(
              compulsoryTransportForm.find('input[name="phone_number"]').val(),
            );
          verifyPhoneNumberModal
            .find("input[name=otp]")
            .val("")
            .trigger("focus");
        } else if (action === "open_iframe") {
          openIframePopup("ISB", response["iframe_url"]);
        } else {
          // some other action
          ajaxErrorAlert(response, form);
        }
      })
      .catch((errors) => {
        if (errors["error_in"]) {
          delete errors["error_in"];
          form.loading({
            loadingText: getJsContext("please_wait") + "...",
            action: "show",
            extraClasses: "spinner-fixed",
          });
          setTimeout(() => {
            form.loading({ action: "hide" });
            ajaxErrorAlert(errors, form);
          }, 3000);
        } else {
          ajaxErrorAlert(errors, form);
        }
      });
  });

  verifyPhoneNumberForm.on("submit", (e) => {
    e.preventDefault();
    const form = $(e.target);
    const data = form.serializeArray();

    form.loading({
      loadingText: getJsContext("please_wait") + "...",
      action: "show",
      extraClasses: "spinner-fixed",
    });
    data.push({
      name: "action",
      value: "verify_phone_number",
    });

    ajaxPost("", data, form)
      .then(() => {
        compulsoryTransportForm
          .find('input[name="otp"]')
          .val(form.find("input[name=otp]").val());
        compulsoryTransportForm.find(".otpCodeField").show();
        Modal.getInstance("#verifyPhoneNumberModal").hide();
        compulsoryTransportForm.loading({
          loadingText: getJsContext("please_wait") + "...",
          action: "show",
          extraClasses: "spinner-fixed",
        });
        compulsoryTransportForm.trigger("submit");
      })
      .catch((errors) => {
        ajaxErrorAlert(errors, form, false);
      });
  });

  $(".resendOtpCode").on("click", (e) => {
    e.preventDefault();
    const form = $(e.target).closest("form");
    form.find("input[name=otp]").val("");
    $(".otpCodeField").hide();
    form.trigger("submit");
  });

  const paymentDetailFields = $(".paymentDetailFields");
  if (paymentDetailFields.length) {
    paymentDetailFields.show();
    ajaxPost("", { action: "get_payment_details" })
      .then((response) => {
        paymentDetailFields.find(".paymentDetailLoadingSpinner").remove();
        paymentDetailFields
          .find('input[name="payment_code"]')
          .val(response["payment_code"]);
        paymentDetailFields
          .find('input[name="payment_amount"]')
          .val(response["payment_amount"]);
      })
      .catch((errors) => {
        paymentDetailFields.hide();
        console.error(
          "An error occurred while getting payment details:",
          errors,
        );
      });
  }
}
